import React, { useState, useEffect, useRef } from 'react';
import Footer from './Footer';
import { getMarkDown, getMarkDownWithInfoButton, formatCardLoadTiming, getButtonWithArrow, useNextButtonWidthClass } from '../utils';
import { useTiming } from '../TimingContext';
import { useCardLoadTiming } from '../hooks/useCardLoadTiming';
import '../../../stylesheets/triagebot/GroupMultiSelect.scss';

function getWindowDimensions() {
  const width = window.innerWidth;
  return width;  
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const GroupMultiMessage = ({ message, sendMessage, setToastMessage, disabled }) => {
  const width = useWindowDimensions();

  const explication = (message.data && message.data.length && message.data[0].explication)
    ? message.data[0].explication
    : '';

  const headerText = (message && message.data && message.data.length && message.data[0].headerText)
    ? message.data[0].headerText
    : '';

  const subHeaderText = (message && message.data && message.data.length && message.data[0].radiobuttonsubHeaderText)
    ? message.data[0].radiobuttonsubHeaderText
    : '';

  const infoMean = ( message?.data?.[0]?.infoHeadText)
  ? message.data[0].infoHeadText
  : 'What does this mean?';


  const questionId = (message && message.data && message.data.length && message.data[0] && message.data[0].question_id)
    ? message.data[0].question_id
    : '';

  const questions = (message && message.data && message.data.length)
    ? [].concat.apply([], message.data.filter(data => Array.isArray(data) && data.length && data[0].question && data[0].choices))
    : [];

  const [answers, setAnswers] = useState(new Array(questions.length).fill(-1));
  const [submitted, setSubmitted] = useState(false);
  const [editing, setEditing] = useState(false);
  const nextButtonClass = useNextButtonWidthClass();

  const nextButton =(message.data?.[0].nextButtonText)
        ? message.data?.[0].nextButtonText
        : ''

  const isCompleted = answers.filter(answer => answer > -1).length === answers.length;

  const isDisabled = submitted || disabled;

  const group = useRef();
  const headingRef = useRef(null);

      const { logTiming } = useTiming();
      const cardName = (message.data && message.data[0] && message.data[0].question_id) ? message.data[0].question_id : "Prompt";
       useCardLoadTiming({
                    sentAt: message._sentAt,
                    cardName,
                    logTiming,
                    formatCardLoadTiming
                });

  const choicePress = (question, value) => {
    if (isDisabled) return;

    let newAnswers = [...answers];
    newAnswers[question] = value;

    setAnswers(newAnswers);

    setTimeout(() => {
      document.activeElement.blur();
    }, 0);
  };

  const submitPress = (event) => {
    if (!isCompleted) return;

    if (submitted) {
      sendMessage('rewind', questionId, questionId,cardName);
      setSubmitted(false);
      setEditing(true);
      return;
    }

    var submitValue = '';

    submitValue = answers.map((answer, question) => {
      return (questions[question].choices[answer].id === undefined) ? questions[question].choices[answer].label : questions[question].choices[answer].id
    }).join();

    editing
      ? sendMessage('message', `##edit@${message.data[0].question_id}@${submitValue || 'none'}`, `##edit@${message.data[0].question_id}@${submitValue || 'none'}`, cardName)
      : sendMessage('message', submitValue || 'none', submitValue || 'none',cardName);

    setSubmitted(true);
  };

  useEffect(() => {
    const focusTimer = setTimeout(() => {
      headingRef.current?.focus({ preventScroll: true });
    }, 500);

    return () => clearTimeout(focusTimer);
  }, [cardName])

  return (
    <div ref={group} className={isDisabled ? 'disabled group-multi card' : 'group-multi card'}>
      <div className='content' >
        <div className='header'>
          <h2 className='headerText headerTextColor' ref={headingRef} tabIndex={-1}>
          {
             (explication && explication!=="none")
              ? getMarkDownWithInfoButton(headerText ? headerText : message.text, explication, setToastMessage, isDisabled, infoMean)
              : getMarkDown(headerText ? headerText : message.text)
          }
          </h2>
          <div className='subheader'>
            {getMarkDown(subHeaderText)}
          </div>
        </div>
        <div className='body'>
          {
            questions.map((question, qkey) => {
              return (
                <div className={(width < 725) ? 'mobile-radio-bar' : 'radio-bar'} 
                  key={'question' + questionId + qkey} 
                  aria-labelledby={questionId + qkey}
                  role='radiogroup'
                >
                  <div className='radio-question' id={questionId + qkey}>
                    <div className='question-row' >
                      {
                         (question.explication && question.explication!=="none")
                          ? getMarkDownWithInfoButton(question.question, question.explication, setToastMessage, isDisabled, infoMean)
                          : getMarkDown(question.question)
                      }
                    </div>
                  </div>
                  <div className='radio-answer'>
                    {
                      question.choices.map((choice, ckey) => {
                        const isSelected = (answers[qkey] === ckey);
                        return (
                          <div
                            key={'question' + questionId + qkey + ckey}
                            className='radio-button'
                          >
                            <button
                              id={choice.label+ qkey + ckey}
                              className={isSelected ? 'selected button' : 'button'}
                              disabled={isDisabled}
                              style={{cursor: 'pointer'}}
                              aria-label={choice.label}
                              role='radio'
                              aria-checked={isSelected ? 'true' : 'false'}
                              onClick={() => choicePress(qkey, ckey)}
                            >
                              <div className='dot' />
                            </button>
                              <span>{choice.label}</span>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>

      <Footer
        showChangeButton={questionId && submitted && !message.isLastMessage}
        onAccepted={submitPress}
        onDenied={() => sendMessage('fastforward')}
        disabled={disabled}
        divID={questionId}
        message={message}
      >
        {
          submitted ||
          <button
            onClick={submitPress}
            className={`submit-button ${nextButtonClass}`.trim()}
            disabled={!isCompleted || isDisabled}
            style={{display: isDisabled ? 'none' : ''}}
            aria-hidden={isDisabled ? 'true': 'false'}
          >
            {getButtonWithArrow(nextButton)}
          </button>
        }
      </Footer>

    </div >
  );
};

export default GroupMultiMessage;
	